export const JWT_KEY = 'jwt';

export let API_BASE_URL = (import.meta.env.VITE_APP_API as string | undefined) ?? '';

if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  // 로컬 개발 서버에서는 무조건 프록시를 타도록 상대 경로로 재설정합니다.
  // (start-prod 명령어 등에서 CORS가 발생하는 것을 방지하기 위함)
  API_BASE_URL = '';
}
export const NEGOTIATION_NOTIFICATION_STORAGE_KEY = 'acepharm_negotiation_notification_enabled';

// 배너용 기존 이미지 API 엔드포인트 (임시 사용 - 추후 S3로 전환 예정)
export const BANNER_IMAGE_ENDPOINT = '/api/image/public';

// S3 이미지 저장소 URL (환경별)
export const S3_IMAGE_BASE_URL_DEV = 'https://dev-acepharm-s3-public-files-bucket.s3.ap-northeast-2.amazonaws.com';
export const S3_IMAGE_BASE_URL_PROD = 'https://acepharm-s3-public-files-bucket.s3.ap-northeast-2.amazonaws.com';
// VITE_APP_ENV 환경 변수로 환경 구분 (development가 아니면 production으로 간주)
const isDevelopmentEnv = import.meta.env.VITE_APP_ENV === 'development';
export const S3_IMAGE_BASE_URL = isDevelopmentEnv ? S3_IMAGE_BASE_URL_DEV : S3_IMAGE_BASE_URL_PROD;

// 디버깅용 로그 (개발 환경에서만)
if (import.meta.env.DEV || isDevelopmentEnv) {
  console.log('[S3 Config]', {
    VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
    MODE: import.meta.env.MODE,
    isDevelopmentEnv,
    S3_IMAGE_BASE_URL,
  });
}

// 주문 상태 한글 매핑
export const ORDER_STATUS_MAP: Record<string, string> = {
  PAYMENT_PREPARING: '결제 준비 중',
  PENDING: '결제 대기',
  DEPOSIT_PENDING: '입금 대기',
  EXPIRED: '주문취소(입금기한만료)',
  PAID: '결제 완료',
  PREPARING: '상품 준비중',
  PARTIAL_SHIPPED: '부분 배송',
  SHIPPED: '배송중',
  SHIPPING: '배송중',
  DELIVERED: '배송 완료',
  PARTIAL_CANCELLED: '부분 취소',
  CANCEL_REQUESTED: '취소 요청',
  CANCELLED: '주문 취소',
  REFUNDED: '환불 완료',
};
